import GenericForm from "../components/forms/genericForm/GenericForm";
import HektorForm from "../components/forms/hektorForm/HektorForm";

const typeFormToComponent: any = {
    generic: {component: GenericForm, transactionStatuses: ['new', 'confirmation-info', 'pending']},
    hektor: {component: HektorForm, transactionStatuses: ['new', 'confirmation-info', 'pending']},
};

export default typeFormToComponent;
